import { isActive } from './isActive'
import { BankingCard } from './types'

export const canDeactivateCard = (card: BankingCard | null | undefined): boolean => {
  return card?._policies?.deactivate?.can === true && isActive(card)
}
